const ChainedBackend = require('i18next-chained-backend').default;
const HttpBackend = require('i18next-http-backend/cjs');
const LocalStorageBackend = require('i18next-localstorage-backend').default;

const isBrowser = typeof window !== 'undefined';

/** @type {import('next-i18next').UserConfig} */
module.exports = {
    backend: {
        backendOptions: [
            { expirationTime: 60 * 60 * 1000 },
            {
                loadPath: '/static/locales/{{lng}}/{{ns}}.json'
            }
        ],
        backends: isBrowser ? [LocalStorageBackend, HttpBackend] : []
    },
    compatibilityJSON: 'v3',
    defaultNS: 'translations',
    fallbackLng: {
        'de-AT': ['de-CH', 'en-GB'],
        'de-DE': ['de-CH', 'en-GB'],
        'de-LI': ['de-CH', 'en-GB'],
        'de-LU': ['de-CH', 'en-GB'],
        'fr-BE': ['fr-FR', 'en-GB'],
        'fr-CA': ['fr-FR', 'en-GB'],
        'fr-CH': ['fr-FR', 'en-GB'],
        'fr-LU': ['fr-FR', 'en-GB'],
        'fr-MU': ['fr-FR', 'en-GB'],
        'it-CH': ['it-IT', 'en-GB'],
        'en-US': ['en-GB'],
        de: ['de-CH'],
        default: ['en-GB'],
        en: ['en-GB'],
        fr: ['fr-FR'],
        it: ['it-IT'],
        nl: ['nl-NL'],
        sv: ['sv-SE']
    },
    i18n: {
        defaultLocale: 'en-GB',
        locales: ['en-GB', 'de-CH', 'fr-FR', 'it-IT', 'nl-NL', 'sv-SE'],
        localeDetection: false
    },
    keySeparator: '::',
    localePath: './public/static/locales',
    ns: ['translations'],
    nsSeparator: '>>',
    reloadOnPrerender: process.env.NODE_ENV === 'development',
    serializeConfig: true,
    use: isBrowser ? [ChainedBackend] : [],
    returnEmptyString: false
};
